import script from "./AddressManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressManage.vue?vue&type=script&setup=true&lang=js"

import "./AddressManage.vue?vue&type=style&index=0&id=e8677672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8677672"]])

export default __exports__